export const EXPERIMENT_API = {
    METHOD: 'GET',
    END_POINT: '/api/v0/config/pwa/',
    CONTENT_TYPE: 'application/json',
};
//# sourceMappingURL=apis.js.map